import(/* webpackMode: "eager" */ "/app/src/app/dev/(console)/layout.tsx");
